export default {
  data: [
    {
      dairy: false,
      favorite: false,
      flavor: 'Chocolate',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Egg Nog',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Milk',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Taro',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Four Pudding',
      premium: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/pudding_flavors.js